module.exports = __webpack_public_path__ + "img/2.f7e9058f.png";